module.exports = __webpack_public_path__ + "img/pr-5.27888034.png";